import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';
import AppProviders from './AppProviders';
import AppLayout from './AppLayout';
import AppRoutes from './AppRoutes';
import GlobalModals from '../components/GlobalModals';
import { SITE_NAME, SITE_URL } from '../shared/Seo';

const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/assets/ponpon-logo.svg`,
  sameAs: [
    'https://www.instagram.com/ponpon.app',
    'https://www.tiktok.com/@ponpon.app',
  ],
};

const WEBSITE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const App = () => {
  return (
    <HelmetProvider>
      <AppProviders>
        {/* CHANGED: Only output jsonLd, no SEO tags to avoid canonical fallback */}
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(ORGANIZATION_SCHEMA)}
          </script>
          <script type="application/ld+json">
            {JSON.stringify(WEBSITE_SCHEMA)}
          </script>
        </Helmet>
        <AppLayout>
          <AppRoutes />
        </AppLayout>
        <GlobalModals />
      </AppProviders>
    </HelmetProvider>
  );
};

export default App;
